import z from 'zod';
// e.g. 0,0: "A"
// 0,3: "B"
export const crossword_solution_data_player_values_schema = z.record(z
    .string()
    .trim()
    .regex(/^\d+,\d+$/), z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z]*$/)
    .min(0)
    .max(1));
// e.g. 0,0: { time: 123456789 }
// 0,3: { time: 123456789 }
export const crossword_solution_data_player_values_metadata_schema = z.record(z
    .string()
    .trim()
    .regex(/^\d+,\d+$/), z.object({
    time: z.number().min(0),
}));
export const crossword_solution_data_player_actions_schema = z.object({
    // e.g. [0,0 , 0,1]
    cell_checks: z.array(z
        .string()
        .trim()
        .regex(/^\d+,\d+$/)),
    // e.g. [0,0 , 0,1]
    cell_reveals: z.array(z
        .string()
        .trim()
        .regex(/^\d+,\d+$/)),
    // e.g. [1-across , 2-across]
    entry_checks: z.array(z
        .string()
        .trim()
        .toLowerCase()
        .regex(/^\d+-(across|down)$/)),
    // e.g. [1-across , 2-across]
    entry_reveals: z.array(z
        .string()
        .trim()
        .toLowerCase()
        .regex(/^\d+-(across|down)$/)),
});
export const crossword_solution_data_schema = z.object({
    player_values: crossword_solution_data_player_values_schema,
    player_values_metadata: crossword_solution_data_player_values_metadata_schema.optional(),
    player_actions: crossword_solution_data_player_actions_schema.optional(),
});
//# sourceMappingURL=crossword-solution.js.map